import WorkoutBanner from "../workoutBanner";
import Workout from "../../../assets/images/jpeg/virtualWorkout.jpg";
import WorkoutFeature from "../workoutFeature";
import WorkoutSetup from "../workoutSetup";
import SlidingText from "../../../components/SlidingText";
import TestimonialCarousel from "../../../components/TestimonialCarousel";
import featureOne from "../../../assets/images/webp/programs/featureOne.webp";
import featureTwo from "../../../assets/images/webp/programs/featureTwo.webp";
import featureThree from "../../../assets/images/webp/programs/featureThree.webp";
import VirtualLargeImage from "../../../assets/images/webp/programs/virtualBigImage.webp";

import CONSTANTS from "../../../utils/constants/CONSTANTS";

import "../index.scss";

const Virtual = () => {
  const featureData = [
    {
      featureImg: featureOne,
      title: "TOTALLY CUSTOMIZED",
      description: "Work towards YOUR specific goals. No cookie cutter programs!",
    },
    {
      featureImg: featureTwo,
      title: "CREATIVE WORKOUTS",
      description: "Use whatever you currently have available to you!",
    },
    {
      featureImg: featureThree,
      title: "UNMATCHED CONVENIENCE",
      description: "Have access to a great workout with a live trainer, wherever you are!",
    },
  ];
  return (
    <div className="virtual-workout">
      <WorkoutBanner
        mainHeading="Go Virtual"
        workoutImage={Workout}
        mainDescription="Taking our customized, convenient, and creative approach one step further, virtual training with Omni-Active® Fitness allows our clients to get a great workout, regardless of their whereabouts. Live workouts with a trainer allow us to adjust on-the-fly when needed, but a virtual approach delivers on unmatched convenience by allowing you to train anywhere, anytime."
      />
      <div className="program-testimonials">
        <TestimonialCarousel images={CONSTANTS.virtualTestimonials} />
      </div>
      <div className="workout-features">
        {featureData.map((feature, index) => {
          return (
            <WorkoutFeature
              key={index}
              featureImg={feature.featureImg}
              title={feature.title}
              description={feature.description}
            />
          );
        })}
      </div>
      <WorkoutSetup
        description="Taking our customized, convenient, and creative approach one step further, virtual training with Omni-Active® Fitness allows our clients to get a great workout, regardless of their whereabouts."
        pointOne="Sign up & subscribe for virtual workouts"
        pointTwo="Trainer sets up sessions at your preferred time "
        pointThree="Join the sessions via video call and workout with constant 
        monitoring and assitance from your trainer "
      />
      <div className="large-image">
        <img className="image" src={VirtualLargeImage} alt="" />
      </div>

      <SlidingText heading="So what are you" subHeading="waiting for?" />
    </div>
  );
};
export default Virtual;
